module.exports = __webpack_public_path__ + "static/media/step-02.dce91e29.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/fiduciaria/img/step-02.png
 ** module id = 1417
 ** module chunks = 0
 **/